






















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import { mdiPlay } from '@mdi/js'
import MixinGeneral from '~/assets/mixins/general'
import { IVideoItem } from '~/assets/interfaces/video'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImage from '~/components/images/image.vue'

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
  },
})
export default class ComponentVideoButton extends mixins(MixinGeneral) {
  @Prop({ type: Object, default: () => {} }) private video!: IVideoItem

  private mdiPlay = mdiPlay
}
